module.exports = __webpack_public_path__ + "img/bold.52d38f02.svg";